import styled from 'styled-components'

import { COLOURS } from 'resources'

export const Image = styled.img``
export const ProgressContainer = styled.div`
  display: flex;
  flex-grow: 1;
  background-color: ${COLOURS.lightGrey2};
  border-radius: 10px;
  height: ${(props) => props.height}px !important;
  margin-right: ${(props) => (props.shouldDisplayIcon ? '10px' : '0')};
`
export const Progress = styled.div`
  border-radius: 10px;
  background-color: ${(props) => props.color} !important;
  height: ${(props) => props.height}px !important;
  width: ${(props) => props.width};
`
export const CircleIconContainer = styled.div`
  flex-grow: 0;
  align-self: center;
`
